import { bindActionCreators } from 'redux';
import { connect, QuizSession, addInfo, screenreaderNotification, isTimeUp, getTimerData, takingApiActions, takingActionCreators, reportRCEEvent, getRCEError } from '@instructure/quiz-core';
import { Take as TakePresenter } from './presenter';
export function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId || state.getIn(['quizSessions', 'activeQuizSessionId']);
  var quizSession = QuizSession.create(state.getIn(['quizSessions', quizSessionId]));
  var isOneQuestionAtATime = quizSession.isOneQuestionAtATime();
  var currentSessionItemPosition = state.getIn(['taking', 'currentSessionItemPosition']) || 1;
  var quizSessionStatusOnPageLoad = state.getIn(['taking', 'quizSessionStatusOnPageLoad']) || '';
  var useTimer = state.getIn(['taking', 'timerData', 'timerRunning']);
  var showTimer = quizSession.timeAllowed() > 0;
  var useRecording = state.getIn(['taking', 'timerData', 'timeRecording']);
  var resumeDataLoaded = isOneQuestionAtATime && !quizSession.allowBacktracking || state.getIn(['taking', 'responses']) !== void 0;
  return {
    appContainer: state.getIn(['ui', 'appContainer']),
    isOneQuestionAtATime: isOneQuestionAtATime,
    currentSessionItemPosition: currentSessionItemPosition,
    quizSession: quizSession,
    quizSessionId: quizSessionId,
    quizSessionStatusOnPageLoad: quizSessionStatusOnPageLoad,
    rceError: getRCEError(state),
    resumeDataLoaded: resumeDataLoaded,
    timeIsUp: isTimeUp(state),
    useTimer: useTimer || useRecording,
    showTimer: showTimer,
    persistedPrintFontSize: state.getIn(['printing', 'fontSizePreference'])
  };
}
function mapDispatchToProps(dispatch) {
  var boundTakingApiActions = bindActionCreators(takingApiActions, dispatch);
  return {
    addInfo: bindActionCreators(addInfo, dispatch),
    closeSubmitConfirmationModal: boundTakingApiActions.closeSubmitConfirmModal,
    fetchQuizSession: boundTakingApiActions.confirmSessionStartPage,
    getTimeRemaining: boundTakingApiActions.getTimeRemaining,
    getTimerData: getTimerData,
    reportRCEEvent: bindActionCreators(reportRCEEvent, dispatch),
    newQuizTakingSession: boundTakingApiActions.newQuizTakingSession,
    onQuizSessionReadyForTaking: boundTakingApiActions.onQuizSessionReadyForTaking,
    recordQuizTime: boundTakingApiActions.recordQuizTime,
    screenreaderNotification: bindActionCreators(screenreaderNotification, dispatch),
    submitQuiz: boundTakingApiActions.submitQuiz,
    takingActions: bindActionCreators(takingActionCreators, dispatch)
  };
}
export var Take = connect(mapStateToProps, mapDispatchToProps)(TakePresenter);
export default Take;